export function formatFactorDataRelease(release) {
    const asOf = String(release?.factor_as_of_date || '');
    const date = /^\d{4}-\d{2}-\d{2}$/.test(asOf) ? new Date(`${asOf}T12:00:00Z`) : null;
    const data = date && Number.isFinite(date.getTime())
        ? `${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })} data`
        : 'Factor data';
    const delivered = release?.delivered_at ? new Date(release.delivered_at) : null;
    return delivered && Number.isFinite(delivered.getTime())
        ? `${data} · delivered ${delivered.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })}`
        : data;
}
